/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   *  Вид для претензионого товара.
   */
  app.NewClaimItemView = app.FormView.extend({
    formElement: '.field',
    events: {
      'click .js-delete-claim': 'removeClaim',
      'click .js-edit-claim': 'edit'
    },
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#newst-mini-claim-item');
      this.listenTo(this.model, 'remove', this.remove);
      if (this.model.get('claim_item_response')) {
        new app.ClaimItemResponsesView({
          model: this.model.get('claim_item_response'),
          el: this.$('.claim-item-responses')
        });
        this.$('.js-add-response').show();
      }
    },
    render: function (element, notReplace) {
      if (!element) {
        element = $(this.template({
          model: this._prepareModelDataForRender()
        }));
        if (!notReplace) {
          this.$el.replaceWith(element);
        }
      }
      this.setElement(element);
      return this;
    },
    /**
     * Редактировние претензионого итема
     */
    edit: function () {
      Backbone.trigger('item-view-edit', this.model);
    },
    /**
     * Удаление претензионого итема
     */
    removeClaim: function () {
      var collection = this.model.collection;
      this.model.destroy({
        success: function () {
          collection.trigger('claimItemView:removeClaim');
        }
      });
    },
    /***
     * Подготовка модели к рендеру
     * @private
     */
    _prepareModelDataForRender: function () {
      var modelData = this.model.toJSON();
      if (!_.isArray(modelData.photos)) {
        modelData.photos = [];
      }
      if (this.notLoaded && this.notLoaded.length) {
        _.each(this.notLoaded, function (data) {
          modelData.photos.push({
            url: window.URL.createObjectURL(data.get('file_path'))
          });
        });
      }
      return modelData;
    }
  });
})(jQuery);


}.call(window));